import React, { useState, useCallback } from 'react'
import { useTranslation } from 'i18n'
import Webcam from 'react-webcam'
import CameraIcon from 'images/inline/ugc/camera.svg'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'
import './webcam.scss'

const WebcamCapture = ({ onPhotoSave }) => {
  const { t } = useTranslation(['ugcPhotoUpload', 'common'])
  const webcamRef = React.useRef(null)
  const [imgSrc, setImgSrc] = useState(null)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImgSrc(imageSrc)
  }, [webcamRef, setImgSrc])
  const retake = () => {
    setImgSrc(null)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }
  const handleSaveWebcamPic = () => {
    onPhotoSave(imgSrc)
  }
  return (
    <>
      <button
        className={`btn open-webcam-button dropzone-button`}
        onClick={() => {
          setIsModalOpen(true)
        }}
      >
        <CameraIcon />
        <span>{t('ugcPhotoUpload:webcam.openCta')}</span>
      </button>
      <Modal
        tabIndex={0}
        className={'0'}
        open={isModalOpen}
        onClose={closeModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        closeAfterTransition
      >
        <div className={`webcam-modal on`}>
          <div>
            <div className={`capture-frame`}>
              {!imgSrc && (
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                />
              )}
              {imgSrc && <img src={imgSrc} />}
            </div>
            <div className={`capture-ctrls`}>
              {' '}
              {!imgSrc && (
                <button className={`capture btn`} onClick={capture}>
                  {t('ugcPhotoUpload:webcam.capture')}
                </button>
              )}
              {imgSrc && (
                <>
                  <button className={`capture btn`} onClick={retake}>
                    {t('ugcPhotoUpload:webcam.retake')}
                  </button>
                  <button
                    className={`capture btn`}
                    onClick={() => {
                      handleSaveWebcamPic()
                      closeModal()
                    }}
                  >
                    {t('ugcPhotoUpload:save')}
                  </button>
                </>
              )}
            </div>
          </div>
          <button
            className={`modal-close top-level-close`}
            onClick={closeModal}
            aria-label={t('common:close')}
          ></button>
        </div>
      </Modal>
    </>
  )
}

export default WebcamCapture
